import request from "@/utils/request";
import moment from "moment";
const dtFormat = "YYYYMMDDHH0000";

/**
 * 请求自建站数据
 * 当开始日期与结束日期都为0时，取实时数据
 * 否则取统计数据
 */
const getSelfStationData = (
  dataCode: string,
  element: string,
  stationIds: any,
  startTime: any,
  endTime: any
) => {
  let eleTmp = element;
  if ("win_s_avg_2mi" == element) eleTmp = "win_s_avg_2mi,win_d_avg_2mi";
  if ("win_s_inst_max" == element) eleTmp = "win_s_inst_max,win_d_inst_max";

  const params: any = {
    staIds: stationIds,
    elements: `station_id_c,station_name,datetime,lat,lon,${eleTmp}`,
  };

  const url = `/self_station/surface_data/list/${dataCode}`;
  if (dataCode == "surf_pre_min_data") {
    dataCode = "surf_min_data";
    const remainder = endTime % 500;
    if (remainder > 0) {
      endTime = endTime - remainder;
    } else if (remainder === 0) {
      endTime = endTime - 500;
    }
    params["times"] = endTime;
  } else {
    if (startTime && endTime) {
      // 任意时间
      if (startTime == endTime) {
        // 任意时间开始结束相等
        params["times"] = endTime;
      } else {
        params["timeRange"] = `${startTime},${endTime}`;
      }
    }
  }

  return request
    .get(url, params)
    .then((data) => {
      if (data && data.length > 0) {
        return data;
      }
      return [];
    })
    .catch((err) => {
      console.log(err);
      return [];
    });
};

const statSelfStationData = (
  dataCode: string,
  element: string,
  stationIds: any,
  startTime: any,
  endTime: any
) => {
  let eleTmp = element;
  if ("win_s_avg_2mi" == element) eleTmp = "win_s_avg_2mi,win_d_avg_2mi";
  if ("win_s_inst_max" == element) eleTmp = "win_s_inst_max,win_d_inst_max";

  const params: any = {
    staIds: stationIds,
    elements: `station_id_c,station_name,datetime,lat,lon,${eleTmp}`,
  };

  if (dataCode == "surf_pre_min_data") {
    dataCode = "surf_min_data";
    const remainder = endTime % 500;
    if (remainder > 0) {
      endTime = endTime - remainder;
    } else if (remainder === 0) {
      endTime = endTime - 500;
    }
  }
  params["timeRange"] = `${startTime},${endTime}`;

  const url = `/self_station/surface_stat/list/${dataCode}`;

  return request
    .get(url, params)
    .then((data) => {
      if (data && data.length > 0) {
        return data;
      }
      return [];
    })
    .catch((err) => {
      console.log(err);
      return [];
    });
};

export default {
  getSelfStationData,
  statSelfStationData
};
